const account_center = {
    not_enabled: '帳戶中心尚未啟用。',
    field_not_editable: '欄位不可編輯。',
    field_not_enabled: '欄位未啟用。',
};
export default Object.freeze(account_center);
